import * as React from 'react';
import { useSelector } from 'react-redux';
import { selectPageTitle } from '../../selectors/pageTitle';
import { Title } from '../../components/Title/Title';

export const TitleContainer = () => {
  const title = useSelector(selectPageTitle);

  return <Title>{title}</Title>;
};
